import React from "react"
import { associateQuestionTemplateIds, clearCategories, loadAssociatedQuestionTemplateIds, loadCategoriesQuestionsTree, loadCategoryNodes, loadSurveyTemplateWeights, setWeight, updateWeights } from "../../../actions/categories";
import { showDialog } from "../../../actions/dialog";
import { clearActiveMenuItem, setActiveMenuItem, setupMenu, updateMenuRoot } from "../../../actions/menu";
import { CategoriesStore } from "../../../stores/categories";
import M from "../../../strings";
import { CategoriesTreeSelector } from "../../components/categoriesTreeSelectorControl";
import EntitiesGridControl from "../../components/entitiesGridControl";
import { Layout, Screen, SideBar } from "../../components/layout"
import { PAGES } from "../../../model/vars";
import { getSurveyTemplateMenu, MENU_ITEM_TYPES } from "../../../model/menu";
import { HeaderBlockWithBreadcrumbs } from "../../components/common";
import { Query } from "../../../framework/query";
import { toast } from "../../../plugins";
import { getLoggedUser } from "../../../api/session";
import { secureScreen } from "../../components/secure";


class _SurveyTemplateWeightsForm extends Screen {
    componentDidMount() {
        const id = this.props.entityId;

        CategoriesStore.subscribe(this, state => {
            this.setState({
                weights: state.weights
            }) 
        });

        if (id) {
            updateMenuRoot({
                root: getSurveyTemplateMenu(id)
            });
            setActiveMenuItem({id: "surveyTemplate.weights"});
        }


        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            loadCategoryNodes();
            loadSurveyTemplateWeights({surveyTemplateId});            
        }
    }

    componentWillUnmount() {
        CategoriesStore.unsubscribe(this);

        clearCategories();

        clearActiveMenuItem();
        setupMenu({user: getLoggedUser()});
    }

    async onSave() {
        const surveyTemplateId = this.props.entityId;
        if (surveyTemplateId) {
            await updateWeights({surveyTemplateId, weights: this.state.weights});
            toast(M("weightsSaved"));
        }
    }

    onWeightChange(id, value) {
        setWeight(id, value);
    }

    getActions(data) {
        return [{
            type: "button",
            text: M("save"),
            tooltip: M("weightsManagement"),
            action: this.onSave.bind(this)
        }];
    }

    getTitle() {
        return M("weightsCategorization")
    }

    render() {
        const id = this.props.entityId;

        if (!id) {
            throw new Error("Impossibile entrare nella schermata dei pesi senza entity id");
        }

        return (
            <Layout>
                <SideBar/>
                <HeaderBlockWithBreadcrumbs title={this.getTitle()} actions={this.getActions()}/>
                <CategoriesTreeSelector 
                    manualLoad={true} 
                    showInput={true} 
                    disableSelection={true} 
                    startsCollapsed={false} 
                    onInputChange={this.onWeightChange.bind(this)}
                    disableToggling={false}
                    />
            </Layout>
        )
    }
}

export const SurveyTemplateWeightsForm = secureScreen(_SurveyTemplateWeightsForm)